import { Directive } from '@angular/core';

/**
 * InputNativeDirective - Marks native HTML input elements for component queries
 *
 * This directive is automatically applied to all <input> elements and
 * allows components like <app-input> to find and reference projected input elements
 * using @ContentChild(InputNativeDirective).
 *
 * Usage (automatic):
 * ```html
 * <input type="text" />  <!-- Directive is automatically applied -->
 * ```
 *
 * No explicit usage needed - the directive applies to all input elements.
 * This allows container components to query for inputs without requiring
 * template reference variables (#input) in parent components.
 */
@Directive({
  selector: 'input:not([type="hidden"])',
  standalone: true,
})
export class InputNativeDirective {}
